<script>
	const crudService = require('services/crudService');
	const _ = require('underscore');
	const productService = require('services/productService');
	const Q = require('q');
	const {
		fireEvent,
		events: { OPEN_BINDER, REMOVE_FROM_BINDER }
	} = require('utilities/analyticsUtilities');

	const sorts = {
		defaultSort: 'date',
		date: {
			sorter(a, b) {
				if (a.creationTimestamp < b.creationTimestamp) {
					return 1;
				} else if (a.creationTimestamp > b.creationTimestamp) {
					return -1;
				} else {
					return 0;
				}
			}
		},
		title: {
			sorter(a, b) {
				let productA = a.product;
				let productB = b.product;
				let titleA = productA.alphaTitle || productA.title;
				let titleB = productB.alphaTitle || productB.title;

				if (titleA < titleB) {
					return 1;
				} else if (titleA > titleB) {
					return -1;
				} else {
					return 0;
				}
			}
		},
		grade: {
			sorter(a, b, direction) {
				let productA = a.product;
				let productB = b.product;
				let gradeA = null;
				let gradeB = null;

				if (direction === 'desc') {
					gradeA = productA.displayGradeOrder || productA.maxGradeOrder;
					gradeB = productB.displayGradeOrder || productB.maxGradeOrder;
				}
				if (direction === 'asc') {
					gradeA = productA.displayGradeOrder || productA.minGradeOrder;
					gradeB = productB.displayGradeOrder || productB.minGradeOrder;
				}

				if (gradeA < gradeB) {
					return 1;
				} else if (gradeA > gradeB) {
					return -1;
				} else {
					return 0;
				}
			}
		},
		lexile: {
			sorter(a, b, direction) {
				let productA = a.product;
				let productB = b.product;
				let lexileA = null;
				let lexileB = null;

				if (productA.productType !== 'A') {
					if (direction === 'desc') {
						lexileA = productA.maxLexile;
					}
					if (direction === 'asc') {
						lexileA = productA.minLexile;
					}
				} else {
					lexileA = (productA.lexile && productA.lexile[0]) || 0;
				}

				if (productB.productType !== 'A') {
					if (direction === 'desc') {
						lexileB = productB.maxLexile;
					}
					if (direction === 'asc') {
						lexileB = productB.minLexile;
					}
				} else {
					lexileB = (productB.lexile && productB.lexile[0]) || 0;
				}

				if (lexileA < lexileB) {
					return 1;
				} else if (lexileA > lexileB) {
					return -1;
				} else {
					return 0;
				}
			}
		},
		generateKeySort(sortKey) {
			return (a, b) => {
				let productA = a.product;
				let productB = b.product;
				if (productA[sortKey] < productB[sortKey]) {
					return 1;
				} else if (productA[sortKey] > productB[sortKey]) {
					return -1;
				} else {
					return 0;
				}
			};
		}
	};

	module.exports = {
		components: {
			'article-result-content': require('components/article-result-content.vue').default
		},
		data() {
			return {
				searchString: '', // used as filter to search for items in view
				products: [], // copy of raw my list contents, sorted specifically for this view
				productToAssign: '', // product to assign when user uses assign modal
				failedProductIds: [],
				binder: null, // raw my list contents
				sorts
			};
		},
		methods: {
			/**
			 * Clears the view search string.
			 */
			clearSearchString: function clearSearchString() {
				this.searchString = '';
			},
			removeStaleProducts: function (productIds) {
				this.$refs.productsDeleted.show();

				productIds.forEach(
					function (p) {
						crudService.remove('myList', p);
					}.bind(this)
				);
			},
			removeProduct: function removeProduct(productId) {
				fireEvent(REMOVE_FROM_BINDER, {
					p: productId
				});

				return crudService.remove('myList', productId);
			},
			clickAssign: function (productId) {
				this.productToAssign = productId;
			},
			onSortSelect(event) {
				let value = event && event.target ? event.target.value : null;
				let key = value ? value.split('_')[0] : null;
				let direction = value ? value.split('_')[1] : null;

				if (key && direction) {
					this.sortProducts(key, direction);
				}
			},
			sortProducts(key, direction) {
				key = key || sorts.defaultSort;
				let sortKey = sorts[key] ? sorts[key].key : null;
				let directionFactor = direction === 'asc' ? -1 : 1;
				let defaultSorter = sorts.generateKeySort(sortKey);

				let sorter = (sorts[key] && sorts[key].sorter) || defaultSorter;
				this.products.sort((a, b) => {
					return directionFactor * sorter(a, b, direction);
				});
			}
		},
		computed: {
			subTitle: function () {
				let subTitle = '';
				let products = this.products;

				if (!products) {
					return subTitle;
				}

				if (products && products.length === 0) {
					subTitle = '(Nothing Saved)';
				} else if (products.length === 1) {
					subTitle = '(One Item)';
				} else {
					subTitle = '(' + products.length + ' Items)';
				}

				return subTitle;
			}
		},
		watch: {
			binder: function (value) {
				var self = this;

				if (value) {
					var sortedBinder = value.slice();
					let sortKey = sorts.defaultSort;
					let sorter = sorts[sortKey].sorter;

					var promises = [Q()];

					self.failedProductIds = [];

					_.each(sortedBinder, function (product) {
						// Fetch product metadata
						promises.push(
							productService.get(product.productId).then(
								function (p) {
									if (p) {
										product.product = p;
									}
									return true;
								},
								function (err) {
									if (err.status === 403) {
										self.failedProductIds.push(product.productId);
									} else {
										throw err;
									}
								}
							)
						);
					});

					Q.allSettled(promises).then(function () {
						sortedBinder.sort(sorter);
						self.products = sortedBinder;

						if (self.failedProductIds.length > 0) {
							self.removeStaleProducts(self.failedProductIds);
						}

						self.$emit('data-ready');
					});
				} else {
					this.products = null;
				}
			}
		},
		mounted() {
			var self = this;

			fireEvent(OPEN_BINDER);

			crudService.read('myList').then(function (binder) {
				self.binder = binder;

				self.$emit('data-ready');
			});
		}
	};
</script>
<style lang="scss">
	.my-list {
		.toolbar {
			flex: 1;
			display: flex;
			align-items: baseline;
			justify-content: flex-end;

			.input-select {
				max-width: 15rem;
			}
		}

		.article-actions {
			.column {
				padding: 0 0 0.25rem 0.25rem;
			}

			.button {
				margin-right: 0.25rem;
			}
		}
	}
</style>
<template>
	<div>
		<div class="main-content wrapper my-list">
			<div class="toolbar form">
				<label
					class="margin-right-medium"
					for="sort-my-list"
					>Sort By</label
				>
				<div class="input-select slim">
					<select
						id="sort-my-list"
						@change="onSortSelect">
						<option
							value="date_desc"
							selected>
							Date Added (New to Old)
						</option>
						<option value="date_asc">Date Added (Old to New)</option>
						<option value="title_asc">Title (A to Z)</option>
						<option value="title_desc">Title (Z to A)</option>
						<option value="grade_asc">Grade (K to 12th)</option>
						<option value="grade_desc">Grade (12th to K)</option>
						<option value="lexile_asc">Lexile (Low to High)</option>
						<option value="lexile_desc">Lexile (High to Low)</option>
					</select>
				</div>
			</div>
			<div
				class="rte empty-message"
				v-if="products.length === 0">
				<p>To add items to this list, <a href="find-content">search for them</a> and add them to 'My List'.</p>
			</div>
			<div
				class="my-articles"
				v-if="products.length > 0">
				<div
					v-for="product in products"
					:key="product.productId"
					class="product-row-item">
					<article-result-content
						:article="product.product"
						:show-summary="false">
						<div
							slot="title-tools"
							class="article-actions row">
							<div class="column medium-6 small-12">
								<button
									data-modal="#modal-assign"
									class="button -small assign"
									@click.prevent="clickAssign(product.product.id)">
									Assign
								</button>
							</div>
							<span class="column medium-6 small-12">
								<button
									v-progress-click.prevent="() => removeProduct(product.productId)"
									class="button -small -outline remove">
									Remove
								</button>
							</span>
						</div>
					</article-result-content>
				</div>
			</div>
		</div>
		<assignment-modal
			show-article-title
			v-bind:product-id="productToAssign"></assignment-modal>
		<modal
			ref="productsDeleted"
			centered
			ok>
			<template slot="header-container">
				<h2>Products Unpublished</h2>
			</template>
			<template slot="content">
				<p>
					{{ failedProductIds.length }} {{ failedProductIds.length === 1 ? 'product' : 'products' }}
					<template v-if="failedProductIds.length > 1"> have </template>
					<template v-else> has </template>
					been unpublished and will be removed from your list.
				</p>
			</template>
		</modal>
	</div>
</template>
